import { useState } from "react";
import api from "../services/api";
import 'bulma/css/bulma.min.css';
import { useAuthContext } from "../context/authContext";
import "../css/LoginUsuario.css";

const LoginUsuario = () => {
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const { loginin } = useAuthContext();

  const Login = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post(`/usuarios/login`, { Username, Password });

      loginin(data.token);
      localStorage.setItem("token", data.token);
      localStorage.setItem("idUsuario", data.idUsuario);
      localStorage.setItem("nombreUsuario", data.nombreUsuario);
      localStorage.setItem("rolUsuario", data.rol);

      // Asignar patología seleccionada si existe en localStorage
      const patologiaSeleccionada = localStorage.getItem("patologiaSeleccionada");
      const idUsuario = parseInt(localStorage.getItem("idUsuario"));
      if (patologiaSeleccionada && idUsuario) {
        const idPatologia = parseInt(patologiaSeleccionada);
          try {
          await api.post(
            `/patologias-usuario`,
            { idUsuario, idPatologia, esDefault: true },
            { headers: { "Content-Type": "application/json" } }
          );
          console.log("Patología asignada correctamente.");
        } catch (err) {
          // Si ya existe, no rompa la app
          if (err.response && err.response.status === 400) {
            console.log("La patología ya estaba asignada.");
          } else {
            console.error("Error asignando patología:", err.message);
          }
        }
      }

      //window.location.reload();
    } catch (error) {
      console.error("Error en login:", error.message);
      alert(error.response?.data?.msg || "Error en el inicio de sesión");
    }
  };

  const backgroundStyle = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "url('/imagenes/background-home.jpg.png')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };

  const boxStyle = {
    width: "350px",
    padding: "2.5rem",
    borderRadius: "15px",
    background: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
    color: "white",
    textAlign: "center",
  };

  return (
    <div style={backgroundStyle}>
      <form style={boxStyle} onSubmit={Login}>
        <h1 style={{ marginBottom: "1.5rem", fontSize: "1.8rem", fontWeight: "700", textShadow: "0 0 8px rgba(0,0,0,0.6)" }}>
          Iniciar Sesión
        </h1>

        <div className="field">
          <label className="label" style={{ color: "white" }}>Usuario</label>
          <input
            className="input is-rounded"
            type="text"
            placeholder="Usuario"
            value={Username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="field">
          <label className="label" style={{ color: "white" }}>Contraseña</label>
          <input
            className="input is-rounded"
            type="password"
            placeholder="Contraseña"
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <button className="button is-primary is-fullwidth" type="submit">Ingresar</button>
      </form>
    </div>
  );
};

export default LoginUsuario;
